import locationConstants from '../constants/location';
import locationHelpers from '../helpers/locations/select';

const initialState = {
  detail: null,
  data: [],
  error: false,
  selected: null,
  checkbox: [],
  selectAll: {
    value: false,
    name: 'select_all',
    placeholder: 'Select All'
  }
}

export default function location (state=initialState, action) {
  switch (action.type) {
    case locationConstants.LIST_LOCATION:
      return {
        ...state,
        data: action.data,
        checkbox: locationHelpers.buildLocationDropDown(action.data)
      };
    case locationConstants.CREATE_LOCATION:
      return {
        ...state,
        detail: action.detail
      };
    case locationConstants.RETRIEVE_LOCATION:
      return {
        ...state,
        detail: action.detail
      };
    case locationConstants.UPDATE_LOCATION:
      return {
        ...state,
        detail: action.detail
      };
    case locationConstants.SELECT_LOCATION:
      return {
        ...state,
        selected: action.selected
      };
    case locationConstants.MULTISELECT_LOCATION:
      return {
        ...state,
        checkbox: locationHelpers.updateLocationDropDown(state.data, action.id, action.value)
      };
    case locationConstants.CLEAR_LOCATION:
      return {
        ...state,
        selected: null,
        detail: null
      };
    case locationConstants.SELECT_ALL_LOCATION:
      return {
        ...state,
        selectAll: {
          ...state.selectAll,
          value: action.toggle
        },
        checkbox: locationHelpers.buildLocationDropDown(state.data, action.toggle)
      };
    case locationConstants.SET_LOCATION_ERROR:
      return {
        ...state,
        error: action.error
      };
    case locationConstants.CLEAR_LOCATION_ERROR:
      return {
        ...state,
        error: false
      }
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/location.js
 **/